<div>
    <div *ngIf="(pagesCount && pagesCount > 1)" style="display:inline" data-testid="pagerDiv">
        <ul class="pagination pagination-sm">
            <li><a
                *ngIf="page !== 0"
                (click)="pageChange.emit(0)"
                (keyup.enter)="pageChange.emit(0)"
                tabindex="0"
                data-testid="back-to-start"><i class="fa fa-step-backward" aria-hidden="true"></i></a></li>
            <li><a
                *ngIf="page !== 0"
                (click)="pageChange.emit(page-1)"
                (keyup.enter)="pageChange.emit(page-1)"
                tabindex="0"
                data-testid="back-one-page"><i class="fa fa-backward" aria-hidden="true"></i></a></li>
            <li *ngFor="let n of calculateRange()" >
                <a
                    (click)="pageChange.emit(n)"
                    (keyup.enter)="pageChange.emit(n)"
                    *ngIf="n !== page"
                    tabindex="0"
                    [attr.data-testid]="'pager-link-' + n">{{n+1}}</a>
                <span *ngIf="n === page" [attr.data-testid]="'pager-fakelink-' + n">{{n+1}}</span>
            </li>
            <li><a
                *ngIf="page !== pagesCount - 1"
                (click)="pageChange.emit(pagePlus(1))"
                (keyup.enter)="pageChange.emit(pagePlus(1))"
                tabindex="0"
                data-testid="forward-one-page"><i class="fa fa-forward" aria-hidden="true"></i></a></li>
            <li><a
                *ngIf="page !== pagesCount - 1"
                (click)="pageChange.emit(pagesCount - 1)"
                (keyup.enter)="pageChange.emit(pagesCount - 1)"
                tabindex="0"
                data-testid="forward-to-end"><i class="fa fa-step-forward" aria-hidden="true"></i></a></li>
        </ul>
    </div>
</div>
